import { useFeatureFlagVariantKey } from 'posthog-js/react';

export const useShouldDisplayTestVariant = (featureFlagKeys: string[]) => {
  const featureFlagVariantKeys = featureFlagKeys.map((featureFlag) =>
    useFeatureFlagVariantKey(featureFlag)
  );

  return featureFlagVariantKeys.includes('test');
};
